import { QuestionnaireShell, useQuestionnairePath } from '../common';
import { FormReadOnlyProvider } from '../../common';
import { ConcludeIntakeAction } from './components';
import { INTAKE_QUESTIONNAIRE_BASE_PATH, INTAKE_TAB_CONFIGS, INTAKE_TAB_IDS } from './constants';
import {
  useFetchIntakeQuestionnaire,
  useInitializeIntakeTabStatuses,
  useIntakeTabMenuOptions,
  useIsIntakeQuestionnaireReadOnly,
} from './hooks';
import IntakeQuestionnaireRoutes from './IntakeQuestionnaireRoutes';

export default function IntakeQuestionnaire() {
  useInitializeIntakeTabStatuses();
  useFetchIntakeQuestionnaire();

  const basePath = useQuestionnairePath(INTAKE_QUESTIONNAIRE_BASE_PATH, 'intakeQuestionnaireId');
  const tabOptions = useIntakeTabMenuOptions(basePath);
  const { isReadOnly } = useIsIntakeQuestionnaireReadOnly();

  return (
    <FormReadOnlyProvider readOnly={isReadOnly}>
      <QuestionnaireShell
        tabOptions={tabOptions}
        tabsAriaLabel="Intake questionnaire sections"
        tabConfigs={INTAKE_TAB_CONFIGS}
        basePath={basePath}
        terminalTabId={INTAKE_TAB_IDS.SUBMIT}
        terminalAction={<ConcludeIntakeAction />}
      >
        <IntakeQuestionnaireRoutes />
      </QuestionnaireShell>
    </FormReadOnlyProvider>
  );
}
